import { FILE_PATH } from 'utils/Client/apiPaths'
import {
  accessToken
} from 'utils/tokens'

export const fetchFile = (fileId) => {
  const apiHost = `${process.env.REACT_APP_API_HOST}`
  const filePath = FILE_PATH.replace(':fileId', fileId)

  const token = accessToken()
  const headers = {
    Authorization: `Bearer ${token}`,
  }

  return fetch(`${apiHost}${filePath}`, {
    method: 'GET',
    headers
  })
}

export default {
  fetchFile
}



// WEBPACK FOOTER //
// ./src/utils/Client/files.js